

import apiClient from "./api";

export const accountSignatoryService = {
  // Récupérer les signataires avec pagination
  getPaginated: async (accountId, params = {}) => {
    const {
      pageNumber = 1,
      pageSize = 10,
      searchTerm = '',
      typeSignature = null,
      estSignatairePrincipal = null,
      estRepresentantLegal = null,
      sortBy = 'CreationDate',
      sortDescending = true
    } = params;

    const queryParams = new URLSearchParams({
      pageNumber,
      pageSize,
      sortBy,
      sortDescending
    });

    if (searchTerm) queryParams.append('searchTerm', searchTerm);
    if (typeSignature) queryParams.append('typeSignature', typeSignature);
    if (estSignatairePrincipal !== null) queryParams.append('estSignatairePrincipal', estSignatairePrincipal);
    if (estRepresentantLegal !== null) queryParams.append('estRepresentantLegal', estRepresentantLegal);

    const response = await apiClient.get(
      `/api/AccountSignatory/account/${accountId}/paginated?${queryParams}`
    );
    return response.data;
  },

  // Récupérer les statistiques
  getStats: async (accountId) => {
    const response = await apiClient.get(`/api/AccountSignatory/account/${accountId}/stats`);
    return response.data;
  },

  // Récupérer un signataire par ID
  getById: async (id) => {
    const response = await apiClient.get(`/api/AccountSignatory/${id}`);
    return response.data;
  },

  // Supprimer un signataire
  delete: async (id) => {
    const response = await apiClient.delete(`/api/AccountSignatory/${id}`);
    return response.data;
  }
};